import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { MobileHeaderSpacer } from "../sider";
import { usePagePadding } from "../pagePadding";
import { isTopBarPage } from "./helpers";
import { StudioTopBar } from "./StudioTopBar";

export const StudioHeader = () => {
  const location = useLocation();
  const pagePadding = usePagePadding();

  return (
    <>
      <MobileHeaderSpacer />
      {isTopBarPage(location.pathname) ? (
        <StyledTopBarAnchor>
          <StyledTopBarSlot $right={pagePadding.right}>
            {/* Remount per page so the error boundary inside resets on navigation. */}
            <StudioTopBar key={location.pathname} />
          </StyledTopBarSlot>
        </StyledTopBarAnchor>
      ) : null}
    </>
  );
};

// ─── Styled components ───

// Zero height: the bar floats over the top of the page instead of pushing it down.
const StyledTopBarAnchor = styled.div`
  position: relative;
  z-index: 10;
  height: 0;
`;

// Centred on the breadcrumb row, which starts 24px below the content top;
// aligned with the page's right padding.
const StyledTopBarSlot = styled.div<{ $right: number }>`
  position: absolute;
  top: 17px;
  right: ${({ $right }) => $right}px;
`;
